import { render, staticRenderFns } from "./AccessConfig.vue?vue&type=template&id=2014de20&scoped=true&"
import script from "./AccessConfig.vue?vue&type=script&lang=js&"
export * from "./AccessConfig.vue?vue&type=script&lang=js&"
import style0 from "./AccessConfig.vue?vue&type=style&index=0&id=2014de20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014de20",
  null
  
)

export default component.exports